import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/User';
import { PaginatedResult } from 'src/app/shared/model/paginated-result';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ClientRecharge} from '../../models/ClientRecharge';
import {ClientCredits} from '../../models/ClientCredits';
import {ClientMessages} from '../../models/ClientMessages';
import {ClientClicks} from '../../models/ClientClicks';
import {ClientBlacklist} from '../../models/ClientBlacklist';
import {ClientBlacklistResponse} from '../../models/ClientBlacklistResponse';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(
    private http: HttpClient
  ) { }

  listClients(userId: string, page: number = 1, perPage: number = 10): Observable<PaginatedResult<User[]>> {
    return this.http.get<PaginatedResult<User[]>>(
      `${environment.apiUrl}/users/${userId}/clients?page=${page}&per_page=${perPage}`
    );
  }

  addClient(userId: string, clientId: string): Observable<User> {
    return this.http.post<User>(`${environment.apiUrl}/users/${userId}/clients/${clientId}`, {});
  }

  removeClient(userId: string, clientId: string): Observable<User> {
    return this.http.delete<User>(`${environment.apiUrl}/users/${userId}/clients/${clientId}`);
  }

  getClientRecharges(userId: string, startDate: string, endDate: string): Observable<ClientRecharge[]> {
    let uri = `${environment.apiUrl}/partner/statistics/${userId}/recharges`;
    uri += '?startDate=' + startDate;
    uri += '&endDate=' + endDate;
    return this.http.get<ClientRecharge[]>(uri);
  }

  getClientMessages(userId: string, startDate: string, endDate: string): Observable<ClientMessages> {
    let uri = `${environment.apiUrl}/partner/statistics/${userId}/sent-messages`;
    uri += '?startDate=' + startDate;
    uri += '&endDate=' + endDate;
    return this.http.get<ClientMessages>(uri);
  }

  getClientClicks(userId: string, startDate: string, endDate: string): Observable<ClientClicks> {
    let uri = `${environment.apiUrl}/partner/statistics/${userId}/clicks`;
    uri += '?startDate=' + startDate;
    uri += '&endDate=' + endDate;
    return this.http.get<ClientClicks>(uri);
  }

  getClientCredits(userId: string): Observable<ClientCredits> {
    const uri = `${environment.apiUrl}/partner/statistics/${userId}/credits`;
    return this.http.get<ClientCredits>(uri);
  }

  getClientBlacklist(
    userId: string, phone: string = null, page: number = 1, perPage: number = 10
  ): Observable<PaginatedResult<ClientBlacklist[]>> {
    let uri = `${environment.apiUrl}/partner/statistics/${userId}/blacklist?page=${page}&per_page=${perPage}`;
    if (phone) {
      uri += '&phone=' + encodeURIComponent(phone);
    }
    return this.http.get<PaginatedResult<ClientBlacklist[]>>(uri);
  }

  saveClientBlacklist(userId: string, phones: string[]): Observable<ClientBlacklistResponse> {
    const uri = `${environment.apiUrl}/partner/statistics/${userId}/blacklist`;
    return this.http.post<ClientBlacklistResponse>(uri, { phones });
  }

  deleteClientBlacklist(userId: string, phones: string[]): Observable<ClientBlacklistResponse> {
    const uri = `${environment.apiUrl}/partner/statistics/${userId}/blacklist`;
    return this.http.delete<ClientBlacklistResponse>(uri, { responseType: 'json', body: { phones } });
  }
}
